import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import { Log } from "~/extensions/utils";
import { HanyoKb, PageID, userType } from "~/extensions/utils/DefineTypes";
import { myPageStore } from "~/store/MyPageStore";
import { commonStore } from "~/store/CommonStore";
import RoomSelectArea from "~/components/roomSelect/RoomSelectArea.vue";
import BreadcrumbList from "src/components/BreadcrumbList.vue";
const log = Log.create("TaikyoRoomSelect");
export default defineComponent({
    components: {
        RoomSelectArea,
        BreadcrumbList
    },
    name: "TaikyoRoomSelect",
    setup() {
        const router = useRouter();
        const pageName = commonStore.pageName(PageID.taikyoRoomList);
        //** 行・カード押下時のイベント */
        const onPush = (selectedNyukyokeiyakuNo) => {
            myPageStore.selectedNyukyokeiyakuNo = selectedNyukyokeiyakuNo;
            // 画面遷移
            router.push({ name: "taikyo-room-list-next" });
        };
        return {
            router,
            userType,
            PageID,
            pageName,
            HanyoKb,
            onPush
        };
    }
});
